import { Root } from "./Root";
import { Summary } from "./Summary";
import { Details } from "./Details";

export const CommitmentAccordion = {
    Summary,
    Root,
    Details,
};
